import { render, staticRenderFns } from "./SolicitudesRetiro.vue?vue&type=template&id=ef445736"
import script from "./SolicitudesRetiro.vue?vue&type=script&lang=js"
export * from "./SolicitudesRetiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports